import {errorHandler} from "@/services/errorHandler";

export default {
    name: "version",
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        searchVersionUpdates:(context , payload) =>{
            payload = {
                ...context.getters.getGlobalDateRange,
                ...payload
            }

            return axios.get(synergyApi+`lytsoft-version-management/searchVersions`,{
                params:payload
            }).then(({data})=>data).catch(err=>errorHandler.tomcatError(err));
        },
        submitDBUpdate:(context , payload) =>{
            let user = context.getters.getCurrentUser;
            if (!user) return;
            payload = {
                user: user.Username,
                ...payload
            }
            let url = synergyApi+"lytsoft-version-management/submitVersion"
            return context.dispatch(`sendRequest`,{
                url,
                payload
            })
        },
        declineUpdateRequest:(context , payload) =>{
            let user = context.getters.getCurrentUser;
            if (!user) return;
            payload = {
                declinedBy: user.Username,
                ...payload
            }
            let url = synergyApi+"lytsoft-version-management/declineVersionUpdate"
            return context.dispatch(`sendRequest`,{
                url,
                payload
            })
        },
        approveUpdateRequest:(context , versionNumber) =>{
            let user = context.getters.getCurrentUser;
            if (!user) return;
            let payload = {
                approvedBy: user.Username,
                identifier : versionNumber
            }
            let url = synergyApi+"lytsoft-version-management/approveVersionUpdate"
            return context.dispatch(`sendRequest`,{
                url,
                payload
            })
        },

    }
}